import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import {
  fetchGetItems,
  fetchGetItemById,
  fetchHideShowItem,
  fetchArchiveItem,
  fetchRestoreItem,
  fetchCopyItem,
  fetchExportItemsToFulfillment,
  fetchGetSKUSets,
} from '../../../actions/items';
import { saveProductsPageState } from '../../../actions/pages';
import { showModal } from '../../../actions/modal';

import {
  getCurrencySymbol,
  parseError,
  parseErrorArr,
  getProductEncodedUrl,
} from '../../../helpers';

import {
  ITEMS_COUNT_ON_PAGE,
  ITEMS_PAGE_TABS,
  ITEMS_TYPES,
  ITEMS_FILTER_TYPES,
  EXTRA_ITEMS_PAGE_TABS,
} from '../../../config';
import DesktopLayout from './DesktopLayout';
import MobileLayout from './MobileLayout';
import Adaptive from '../../common/Adaptive';
import qs from 'qs';
import SpinnerBlock from '../../common/SpinnerBlock';

class ItemsPage extends React.Component {
  constructor(props) {
    super(props);

    const { history, pageSavedData, perPageFromRedux } = props;

    this.state = {
      ...pageSavedData,
      isLoaded: false,
      archiveMode: false,
      tableMode: window.innerWidth > 420,
      totalItems: 0,
      loading: false,
      products: [],
      selected: {},
      selectedAll: false,
      page: 0,
      size: perPageFromRedux,
      exportToFulfillmentLoading: false,
      sorting: null,
      activeTab: 'all',
      types: [
        {
          value: 'all',
          label: 'Все',
        },
      ],
      urlSearchStr: '',
      skuSets: null,
    };
  }

  async componentDidMount() {
    await this.handleGetItems();
    this.setState({ isLoaded: true });
    if (this.props.history.location.search) {
      this.setParseSearchStr();
    }
  }

  componentWillUnmount() {
    const { saveProductsPageState } = this.props;
    const { search, page } = this.state;
    saveProductsPageState({ search, page });
  }

  async componentDidUpdate(prevProps, prevState) {
    /* Сохраняем выделение нужных элементов таблицы при изменении поисковой строки */
    if (
      prevState.search !== this.state.search ||
      prevState.barcode !== this.state.barcode ||
      prevState.activeTab !== this.state.activeTab ||
      prevState.types !== this.state.types ||
      prevState.page !== this.state.page ||
      prevState.sorting !== this.state.sorting
    ) {
      await this.handleGetItems();
      const newSelected = this.checkActualSelected();
      this.setState({
        selectedAll: false,
        selected: newSelected,
      });
      const newUrlSearchStr = this.getSearchStr(
        this.state.activeTab,
        this.state.page,
        this.state.types,
        this.state.search,
        this.state.barcode,
        this.state.sorting,
      );
      this.setState({ urlSearchStr: newUrlSearchStr });
    }

    /* Очищаем выделение элементов при переключении режима архива */
    if (prevState.archiveMode !== this.state.archiveMode) {
      this.clearSelected();
    }
    if (prevState.urlSearchStr !== this.state.urlSearchStr) {
      this.props.history.push({
        search: this.state.urlSearchStr,
      });
    }

    if (prevState.activeTab !== this.state.activeTab) {
      this.setState({
        page: 0,
      });
      this.setState({
        types: [
          {
            value: 'all',
            label: 'Все',
          },
        ],
      });
    }
  }

  prepareData() {
    const { products } = this.state;
    const newData = products.slice();
    return newData;
  }

  getSearchStr(activeTab, page, types, search, barcode, sorting) {
    let result = '?';
    if (activeTab && activeTab !== 'all') {
      result += `filters=SKU_TYPE:${ITEMS_FILTER_TYPES[activeTab]}&`;
    }
    const all = types.find((elem) => elem.value === 'all');
    if (!all && types.length) {
      result += `filters=SKU_TYPE:${types
        .map((elem) => ITEMS_FILTER_TYPES[elem.value])
        .join(',')}&`;
    }
    if (page) {
      result += `page=${page}&`;
    }
    if (search) {
      result += `search=${search}&`;
    }
    if (barcode) {
      result += `barcode=${barcode}&`;
    }
    if (sorting) {
      result += `order=${sorting.type.toLowerCase()}+${sorting.direction}&`;
    }
    return result.slice(0, -1);
  }

  parseSearchStr(str) {
    let result = qs.parse(str.slice(1));
    return {
      types: result.filters ? result.filters.replace(/\bSKU_TYPE:\b/g, '').split(',') : null,
      search: result.search,
      barcode: result.barcode,
      page: result.page,
      sorting: result.order,
    };
  }

  checkActualSelected() {
    const { selected } = this.state;
    const data = this.prepareData();
    return Object.keys(selected).reduce((a, id) => {
      if (selected[id] && data.find((item) => item.id === id)) {
        a[id] = true;
      }
      return a;
    }, {});
  }

  clearSelected() {
    this.setState({ selected: {}, selectedAll: false });
  }

  setParseSearchStr() {
    const parseSearch = this.parseSearchStr(this.props.location.search);
    if (parseSearch.types) {
      if (parseSearch.types.length > 1) {
        const newTypes = parseSearch.types.map((item) => {
          return ITEMS_TYPES.find((elem) => ITEMS_FILTER_TYPES[elem.value] === item);
        });
        this.setState({ types: [...newTypes] });
      } else {
        const newActiveTab = EXTRA_ITEMS_PAGE_TABS.find(
          (elem) => ITEMS_FILTER_TYPES[elem.id] === parseSearch.types[0],
        ) || { id: 'consumables_attachment', title: 'Расходные материалы и допвложения' };

        this.setState({ activeTab: newActiveTab.id });
      }
    }
    if (parseSearch.search) {
      this.setState({ search: parseSearch.search });
    }
    if (parseSearch.barcode) {
      this.setState({ barcode: parseSearch.barcode });
    }
    if (parseSearch.page) {
      this.setState({ page: parseSearch.page });
    }
    if (parseSearch.sorting) {
      const newSorting = {
        sorting: {
          type: parseSearch.sorting.split(' ')[0],
          direction: parseSearch.sorting.split(' ')[1],
        },
      };
      this.setState(newSorting);
    }
  }

  handleToggleMainCheckbox() {
    const { selectedAll } = this.state;
    const data = this.prepareData();
    const newSelected = selectedAll
      ? {}
      : data.reduce((a, c) => {
          a[c.id] = true;
          return a;
        }, {});
    this.setState({
      selectedAll: !selectedAll,
      selected: newSelected,
    });
  }

  handleToggleCheckbox(itemId) {
    const { selected } = this.state;
    const currentState = selected[itemId];
    const newSelected = Object.assign({}, selected, { [itemId]: !currentState });
    this.setState({
      selected: newSelected,
      selectedAll: false,
    });
  }

  async handleGetItems({ order } = {}) {
    const { search, barcode, page, size, archiveMode, activeTab, types, sorting } = this.state;
    const { fetchGetItems } = this.props;
    const trimmedSearch = search?.trim() || '';
    let curFilterTypes = '';

    if (activeTab !== 'all') {
      curFilterTypes = ITEMS_FILTER_TYPES[activeTab];
    }

    if (types) {
      const all = types.find((elem) => elem.value === 'all');
      if (!all && types) {
        curFilterTypes = types.map((elem) => ITEMS_FILTER_TYPES[elem.value]).join(',');
      }
    }

    const sortSettings = order
      ? order
      : sorting
      ? `${sorting.type.toLowerCase()}+${sorting.direction}`
      : undefined;

    let sendObj = Object.assign(
      {},
      {
        size,
      },
      { search: encodeURI(trimmedSearch) },
      {
        barcode,
        deleted: archiveMode,
        order: sortSettings,
        type: curFilterTypes,
      },
    );

    if (typeof page !== 'undefined') sendObj.page = page;

    this.setState({ loading: true });

    return await fetchGetItems(sendObj).then((result) => {
      this.setState({
        products: result.products,
        totalItems: result.recordsTotal,
        loading: false,
      });
    });
  }

  updateProduct(productId) {
    const { products } = this.state;
    const { fetchGetItemById } = this.props;
    fetchGetItemById(productId).then((product) => {
      this.setState({
        products: products.map((p) => {
          if (p.id === product.id) return product;
          return p;
        }),
      });
    });
  }

  handleToggleArchive() {
    const { archiveMode } = this.state;
    this.setState({ archiveMode: !archiveMode }, () => {
      this.handleGetItems();
    });
  }

  handleSearch(value) {
    this.setState({
      search: value,
      page: 0,
    });
  }

  handleSearchByBarcode(value) {
    this.setState({
      barcode: value,
      page: 0,
    });
  }

  async handleHideShow(data) {
    const { selected } = this.state;
    const { fetchHideShowItem } = this.props;
    const available = !this.getHideBool(data);
    for (let key in selected) {
      if (selected[key]) {
        const currentItem = data.find((item) => item.id === key);
        if (currentItem) {
          await fetchHideShowItem(Object.assign({}, currentItem, { available }));
        }
      }
    }
    this.clearSelected();
    this.handleGetItems();
  }

  async handleCopyItems() {
    const { selected } = this.state;
    const { fetchCopyItem, items } = this.props;
    for (let key in selected) {
      if (selected[key]) {
        const currentItem = items.data.find((item) => item.id === key);
        if (currentItem) {
          await fetchCopyItem(currentItem.id);
        }
      }
    }
    toast.info('Товар успешно скопированы');
    this.clearSelected();
    this.handleGetItems();
  }

  async handleArchiveItems() {
    const { selected } = this.state;
    const { fetchArchiveItem, items } = this.props;

    for (let key in selected) {
      if (selected[key]) {
        const currentItem = items.data.find((item) => item.id === key);
        if (currentItem) {
          try {
            await fetchArchiveItem(currentItem);
            toast.info(`Товар (id: ${currentItem?.variants?.[0]?.id ?? key}) перенесен в архив`);
          } catch (e) {
            toast.error(parseError(e));
          }
        }
      }
    }
    this.clearSelected();
    this.handleGetItems();
  }

  async handleRestoreItems() {
    const { selected } = this.state;
    const { fetchRestoreItem, items } = this.props;

    for (let key in selected) {
      if (selected[key]) {
        const currentItem = items.data.find((item) => item.id === key);
        if (currentItem) {
          await fetchRestoreItem(currentItem);
        }
      }
    }
    this.clearSelected();
    this.handleGetItems();
  }

  handleGotoItemPage(item, type) {
    const { history } = this.props;
    const { urlSearchStr } = this.state;

    let url = getProductEncodedUrl(
      item === null ? 'new' : item.productId ? item.productId : item.id,
    );

    if (item && item.deleted) {
      url += '?archived';
    }

    history.push({
      pathname: url,
      state: { type: type, customBackLink: urlSearchStr ? '/items' + urlSearchStr : null },
    });
  }

  handleDeliveryModal() {
    const { showModal } = this.props;
    showModal('ExportItems');
  }

  openVariant = (product, variantId, isMonobox) => {
    const { history } = this.props;
    const { urlSearchStr } = this.state;

    const isArchived = product.deleted;

    let url = getProductEncodedUrl(product.id, variantId, null, isMonobox);
    if (isArchived) url += '?archived';

    history.push({
      pathname: url,
      state: { customBackLink: urlSearchStr ? '/items' + urlSearchStr : null },
    });
  };

  handlePageSelect(pageIndex) {
    this.setState({ page: pageIndex });
    this.clearSelected();
  }

  handleUpdateSorting(data) {
    this.setState({ sorting: data });
  }

  handlePerPageValue(perPageValue) {
    this.setState({ size: perPageValue, page: 0 }, () => {
      this.handleGetItems();
    });
    this.clearSelected();
  }

  async handleUploadToFulfillment() {
    const { selected } = this.state;
    const { defaultWarehouse, fetchExportItemsToFulfillment } = this.props;

    if (!defaultWarehouse) {
      toast.error('склад по умолчания не установлен');
      return false;
    }

    if (defaultWarehouse.operatorType !== 'FULFILLMENT') {
      toast.error('склад по умолчания не является фулфиллмент складом');
      return false;
    }

    this.setState({ exportToFulfillmentLoading: true });

    const reqObj = {
      warehouseCode: defaultWarehouse.code,
      products: Object.keys(selected).filter((key) => selected[key] === true),
    };

    await fetchExportItemsToFulfillment(reqObj)
      .then(() => {
        toast.info('Товары успешно выгружены на фулфиллмент');
        this.clearSelected();
        this.handleGetItems();
      })
      .catch((err) => {
        parseErrorArr(err).forEach((mes) => {
          if (mes) {
            toast.error(mes);
          }
        });
      })
      .finally(() => {
        this.setState({ exportToFulfillmentLoading: false });
      });
  }

  getHideBool(data) {
    const { selected } = this.state;
    return Object.keys(selected)
      .filter((key) => selected[key])
      .find((key) => {
        const currentItem = data.find((item) => item.id === key);
        return currentItem && currentItem.available;
      });
  }

  handleOpenTab(tab) {
    this.setState({ page: 0 });
    this.setState({ activeTab: tab.id });
  }

  handleTypeItems(newTypes) {
    this.setState({ page: 0 });
    newTypes ? this.setState({ types: [...newTypes] }) : this.setState({ types: [] });
  }

  render() {
    const { items, checkoutSettings, setMobileCustomMenu } = this.props;
    const {
      isLoaded,
      tableMode,
      archiveMode,
      search,
      barcode,
      totalItems,
      loading,
      selected,
      selectedAll,
      exportToFulfillmentLoading,
      activeTab,
      types,
      urlSearchStr,
      skuSets,
      sorting,
    } = this.state;

    if (!isLoaded) return <SpinnerBlock show={true} />;

    const data = this.prepareData();

    const selectedLength = Object.values(selected).filter((v) => v).length;
    const currencySymbol = getCurrencySymbol(checkoutSettings.currency);

    const adaptiveProps = {
      selectedLength,
      archiveMode,
      exportToFulfillmentLoading,
      data,
      totalItems,
      search,
      barcode,
      tableMode,
      loading,
      currencySymbol,
      items,
      selected,
      selectedAll,
      handleSearch: this.handleSearch.bind(this),
      handleSearchByBarcode: this.handleSearchByBarcode.bind(this),
      handleDeliveryModal: this.handleDeliveryModal.bind(this),
      handleGotoItemPage: this.handleGotoItemPage.bind(this),
      handleGetItems: this.handleGetItems.bind(this),
      updateProduct: this.updateProduct.bind(this),
      handleToggleMainCheckbox: this.handleToggleMainCheckbox.bind(this),
      handleToggleCheckbox: this.handleToggleCheckbox.bind(this),
      openVariant: this.openVariant.bind(this),
      state: this.state,
      handlePageSelect: this.handlePageSelect.bind(this),
      handlePerPageValue: this.handlePerPageValue.bind(this),
      setState: this.setState.bind(this),
      handleToggleArchive: this.handleToggleArchive.bind(this),
      handleUploadToFulfillment: this.handleUploadToFulfillment.bind(this),
      clearSelected: this.clearSelected.bind(this),
      getHideBool: this.getHideBool.bind(this),
      handleCopyItems: this.handleCopyItems.bind(this),
      handleHideShow: this.handleHideShow.bind(this),
      handleArchiveItems: this.handleArchiveItems.bind(this),
      handleRestoreItems: this.handleRestoreItems.bind(this),
      handleUpdateSorting: this.handleUpdateSorting.bind(this),
      activeTab,
      handleOpenTab: this.handleOpenTab.bind(this),
      handleTypeItems: this.handleTypeItems.bind(this),
      types,
      urlSearchStr,
      skuSets,
      setMobileCustomMenu,
      sorting,
    };

    return (
      <Adaptive
        DekstopComponent={DesktopLayout}
        MobileComponent={MobileLayout}
        adaptiveProps={adaptiveProps}
        type="phone"
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    perPageFromRedux: state.app.appSavedState.paginations.productsPage || ITEMS_COUNT_ON_PAGE,
    items: state.items,
    defaultWarehouse: state.orders.warehouses && state.orders.warehouses.find((w) => w.isDefault),
    pageSavedData: state.pages.productsPageState,
    checkoutSettings: state.settings.checkoutSettings,
  };
};

const mapDispatchToProps = {
  fetchGetItems,
  fetchHideShowItem,
  fetchArchiveItem,
  fetchRestoreItem,
  fetchCopyItem,
  fetchExportItemsToFulfillment,
  fetchGetItemById,
  saveProductsPageState,
  showModal,
  fetchGetSKUSets,
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemsPage);
